import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["banner"]

  connect() {
    console.log("Cookie Banner Controller Connected")
    if (!this.getCookie("cookies_accepted")) {
      console.log("No cookie found, showing banner")
      this.bannerTarget.classList.remove("hidden")
      this.bannerTarget.classList.add("flex")
    } else {
      console.log("Cookie found: ", this.getCookie("cookies_accepted"))
    }
  }

  get currentPrefs() {
    const prefs = this.getCookie("cookie_prefs")
    return prefs ? JSON.parse(prefs) : { analytics: false, marketing: false, essential: true }
  }

  acceptAll() {
    this.setCookie("cookies_accepted", "true", 365)
    this.setCookie("cookie_prefs", JSON.stringify({ analytics: true, marketing: true, essential: true }), 365)
    this.hideBanner()
    this.syncWithServer({ analytics: true, marketing: true, essential: true })
  }

  acceptEssential() {
    this.setCookie("cookies_accepted", "true", 365)
    this.setCookie("cookie_prefs", JSON.stringify({ analytics: false, marketing: false, essential: true }), 365)
    this.hideBanner()
    this.syncWithServer({ analytics: false, marketing: false, essential: true })
  }

  hideBanner() {
    this.bannerTarget.classList.add("hidden")
    this.bannerTarget.classList.remove("flex")
  }

  setCookie(name, value, days) {
    let expires = ""
    if (days) {
      let date = new Date()
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
      expires = "; expires=" + date.toUTCString()
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax"
  }

  getCookie(name) {
    let nameEQ = name + "="
    let ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) == ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
    }
    return null
  }

  syncWithServer(prefs) {
    // If the user is logged in, we should sync these prefs to their account
    // We'll use a fetch request to a new endpoint
    fetch("/settings/update_cookie_preferences", {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ cookie_preferences: prefs })
    })
  }
}
